import { create } from 'zustand';

interface FavoriteWindowState {
    favoriteWindow: boolean;
    setFavoriteWindow: (value: boolean) => void;
}

export const useFavoriteWindowStore = create<FavoriteWindowState>((set) => ({
    favoriteWindow: false,
    setFavoriteWindow: (value) => set({ favoriteWindow: value }),
}));

export const useFavoriteWindowStateValue = () => useFavoriteWindowStore((state) => state.favoriteWindow);
export const useSetFavoriteWindowState = () => useFavoriteWindowStore((state) => state.setFavoriteWindow);
